import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EndpointService } from './endpoint.service';
import { GridModel } from '../shared/grid/grid.model';
import { SampleReport } from '../models/corporate-reporting/sampleReport.model';
import { RiskRegisterRollup } from '../models/corporate-reporting/riskRegisterRollup.model';
import { CorporateRiskRollupFilter, CorporateSampleReportFilter } from '../models/corporate-reporting/corporateReportFilter.model';

/**
 * Data-residency Phase 4: reads the PII-redacted, cross-region corporate reporting
 * store. This is NOT a GridService — the corp read path is a lightweight REST
 * surface with fixed typed query params (no dynamic filter/orderBy dictionary,
 * no field-configuration, no export). Access is gated server-side by the
 * AdminOrSuperAdmin authorization policy; a regional user receives 403.
 */
@Injectable({ providedIn: 'root' })
export class CorporateReportingService extends EndpointService {

    constructor(http: HttpClient) {
        super(http);
    }

    getSamples(filter: CorporateSampleReportFilter): Observable<GridModel<SampleReport>> {
        return this.http.get<GridModel<SampleReport>>(
            this.getApiUrl('corporate-reports/samples'),
            { params: this.buildParams(filter) },
        );
    }

    getRiskRollups(filter: CorporateRiskRollupFilter): Observable<GridModel<RiskRegisterRollup>> {
        return this.http.get<GridModel<RiskRegisterRollup>>(
            this.getApiUrl('corporate-reports/risk-rollups'),
            { params: this.buildParams(filter) },
        );
    }

    private buildParams(filter: CorporateSampleReportFilter | CorporateRiskRollupFilter): HttpParams {
        let params = new HttpParams();
        Object.entries(filter).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params = params.set(key, String(value));
            }
        });
        return params;
    }
}
